import React, { useEffect, useState } from 'react';
import ListView from '../../components/views/listView';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {
    HOME,
    TEMPLATES_WSP_EDIT,
    TEMPLATES_WSP_NEW,
} from '../../../routes/paths';
import { MasterMessage } from '../../../masters/masterMessages';
import { useNavigate } from 'react-router-dom';
import { Chip, IconButton, Tooltip } from '@mui/material';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';

import EditIcon from '@mui/icons-material/Edit';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { types } from '../../../redux/types';
import { useDispatch } from 'react-redux';
import {
    asyncGetTemplateList,
    asyncPauseSending,
    asyncReactivateSending,
} from '../../../services/commercialCrm.service';

const WspList = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const [rows, setRows] = useState<any>();
    const [lengthRows, setLengthRows] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);
    const { wspTemplate }: any = MasterMessage;

    const pauseSendingMessages = async (scenery: string) => {
        try {
            await asyncPauseSending(scenery);

            SwalCustomClass.fire({
                icon: 'success',
                text: 'El envío de mensajes fue pausado correctamente.',
            });

            setLoading(true);
            const body: any = await asyncGetTemplateList(page, pageSize);
            setRows(body.items.items);
            setLengthRows(body.items.length);
        } catch (error) {
            SwalCustomClass.fire({
                icon: 'error',
                text: 'Ocurrió un error al pausar el envío.',
            });
        } finally {
            setLoading(false);
        }
    };

    const reactivateSendingMessages = async (scenery: string) => {
        try {
            await asyncReactivateSending(scenery);

            SwalCustomClass.fire({
                icon: 'success',
                text: 'El envío de mensajes fue reactivado correctamente.',
            });

            setLoading(true);
            const body: any = await asyncGetTemplateList(page, pageSize);
            setRows(body.items.items);
            setLengthRows(body.items.length);
        } catch (error) {
            SwalCustomClass.fire({
                icon: 'error',
                text: 'Ocurrió un error al reactivar el envío.',
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        dispatch({ type: types.resetStepper });

        asyncGetTemplateList(page, pageSize)
            .then((body: any) => {
                if (body.items !== undefined) {
                    setRows(body.items.items);
                    setLengthRows(body.items.length);
                } else if (body.message !== undefined) {
                    SwalCustomClass.fire({
                        text: wspTemplate[body.message],
                        icon: 'error',
                        iconColor: '#1d1d1d',
                    });
                }
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, wspTemplate]);

    const paginator = (paginationModel: any) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
        }
    };

    const columns = [
        {
            field: 'description',
            headerName: 'Descripcion',
            minWidth: 100,
            flex: 0.5,
        },
        {
            field: 'scenery',
            headerName: 'Escenario',
            minWidth: 120,
            flex: 1,
        },
        {
            field: 'active',
            headerName: 'Estado',
            minWidth: 100,
            flex: 0.5,
            align: 'center',
            headerAlign: 'center',
            renderCell: (val: any) => {
                switch (val.value) {
                    case true:
                        return (
                            <Chip
                                label="ACTIVO"
                                sx={{ ml: 1, fontSize: 11.5 }}
                                color="success"
                            />
                        );
                    case false:
                        return (
                            <Chip
                                label="INACTIVO"
                                sx={{ ml: 1, fontSize: 11.5 }}
                                color="error"
                            />
                        );
                    default:
                        return (
                            <Chip
                                label="EN PROCESO"
                                sx={{ ml: 1, fontSize: 11.5 }}
                                color="info"
                            />
                        );
                }
            },
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row: any) => (
                <>
                    <Tooltip title="Editar">
                        <IconButton
                            size="small"
                            onClick={() =>
                                navigate(`${TEMPLATES_WSP_EDIT}/${row.id}`)
                            }
                        >
                            <EditIcon color="primary" />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Inicio de envío">
                        <IconButton
                            size="small"
                            onClick={() =>
                                reactivateSendingMessages(row.row.scenery)
                            }
                        >
                            <PlayArrowIcon color="success" />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Detención de envío">
                        <IconButton
                            size="small"
                            onClick={() =>
                                pauseSendingMessages(row.row.scenery)
                            }
                        >
                            <PauseIcon color="warning" />
                        </IconButton>
                    </Tooltip>
                </>
            ),
        },
    ];

    return (
        <ListView
            title={wspTemplate.titleList}
            titleButtonAdd={'Agregar'}
            startIconButtonAdd={<AddCircleIcon color="secondary" />}
            onClickAdd={() => navigate(TEMPLATES_WSP_NEW)}
            onClickBack={() => navigate(HOME)}
            columns={columns}
            rows={rows}
            rowCount={lengthRows}
            disableRow={true}
            loading={loading}
            onSetPage={(paginationModel: any) => paginator(paginationModel)}
        />
    );
};

export default WspList;
